export default __webpack_public_path__ + "static/media/7.c44a2109.jpg";